// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "ad_optimization_outcome".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "ad_optimization_outcome" table (1:1 with a DB row, on the wire). */
export const adOptimizationOutcomeAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    subjectType: z.string(),
    subjectId: z.string(),
    rule: z.string(),
    action: z.string(),
    rulesVersion: z.string(),
    firstFlaggedFor: z.string(),
    lastFlaggedFor: z.string(),
    benchmarkCpl: z.number().nullable(),
    spendAtFlag: z.number().nullable(),
    leadsAtFlag: z.number().nullable(),
    windowDays: z.number(),
    daysObserved: z.number(),
    spendAfter: z.number(),
    leadsAfter: z.number(),
    lastSpendDate: z.string().nullable(),
    leadRateAfter: z.number().nullable(),
    replacementLeads: z.number().nullable(),
    verdict: z.string(),
    final: z.boolean(),
    scoredAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=adOptimizationOutcome.js.map